import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/guide")({
  component: lazyRouteComponent(() => import("./-pages/admin.guide")),
  head: () => ({
    meta: [
      { title: "دليل الموقع · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
